"use strict";
var debounce = require("lodash/debounce");
var productLaunchVideoSliderInit = require("../productLaunch/productLaunch");
var lazyLoading = require("../global/lazyLoading");

/**
 * @description Initializes the slick slider carousels
*/
var slickSettings = {
    mobileFirst: true,
    arrows: false,
    centerMode: true,
    centerPadding: "12%",
    useTransform: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: false,
                speed: 1000
            }
        },
        {
            breakpoint: 1199,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                slidesToShow: 4,
                slidesToScroll: 4,
                centerMode: false,
                speed: 1000
            }
        }
    ]
};

var promoSliderSlickSettings = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
};

var productPageSlickSettings = {
    mobileFirst: true,
    arrows: true,
    dots: true,
    customPaging: customPagination,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".m-product-detail__thumb-images .slick-slider",
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                dots: false,
                arrows: false
            }
        }
    ]
};

var productPageThumbSlickSettings = {
    vertical: true,
    arrows: false,
    focusOnSelect: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    centerMode: false,
    verticalSwiping: true,
    asNavFor: ".m-product-detail__main-carousel .slick-slider",
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                dots: false,
                arrows: false
            }
        }
    ]
};

var playersCarouselSlickSettings = {
    mobileFirst: true,
    arrows: true,
    dots: true,
    customPaging: customPagination,
    useTransform: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
};

var blogTilesCarouselSlickSettings = {
    mobileFirst: true,
    arrows: false,
    centerMode: false,
    useTransform: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 1199,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                slidesToShow: 4,
                slidesToScroll: 4,
                centerMode: false,
                speed: 1000
            }
        }
    ]
};

var productLaunchTilesCarouselSlickSettings = {
    mobileFirst: true,
    arrows: true,
    centerMode: false,
    useTransform: false,
    infinite: false,
    dots: true,
    customPaging: customPagination,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                speed: 1000
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
                speed: 1000
            }
        }
    ]
};

var productSelectorSlickSettings = {
    mobileFirst: true,
    dots: true,
    customPaging: customPagination,
    arrows: false,
    infinite: false,
    slidesToShow: 1.25,
    useTransform: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }
    ]
};

var miniCartSlickSettings = {
    arrows: true,
    dots: true,
    customPaging: customPagination,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                dots: true,
                customPaging: customPagination,
                arrows: true
            }
        }
    ]
};

var zoomPopinSliderSettings = {
    mobileFirst: true,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true
};

var cartProductSlickSettings = {
    mobileFirst: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: 0
            }
        },
        {
            breakpoint: 1279,
            settings: {
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                centerMode: false,
                centerPadding: 0
            }
        }
    ]
};

var pdCarouselSlickSettings = {
    mobileFirst: true,
    arrows: true,
    centerMode: true,
    centerPadding: "12%",
    useTransform: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 1000
            }
        },
        {
            breakpoint: 1199,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                speed: 1000
            }
        }
    ]
};

var anniversaryStoriesCarouselSlickSettings = {
    mobileFirst: true,
    arrows: true,
    dots: false,
    centerPadding: "12%",
    slidesToScroll: 1,
    centerMode: true,
    initialSlide: 0,
    infinite: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: false,
                infinite: false,
                centerPadding: "0%",
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1024,
            settings: {
                centerMode: false,
                infinite: false,
                centerPadding: "0%",
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1279,
            settings: {
                centerMode: false,
                infinite: false,
                centerPadding: "0%",
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
};


/**
 * @description Initializes the anniversary slick slider carousels
*/
var anniversarySlickSettings = {
    mobileFirst: true,
    arrows: true,
    centerMode: true,
    centerPadding: "12%",
    useTransform: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 1000
            }
        },
        {
            breakpoint: 1199,
            settings: {
                arrows: true,
                dots: true,
                customPaging: customPagination,
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                speed: 1000
            }
        }
    ]
};

/**
 * @function
 * @description - create observer instance for observing the einstein injected elements
 */
const runMutationsObserver = container => {
    container.forEach(function (wrapper) {
        var observer = new MutationObserver(() => {
            const carousel = wrapper.querySelector(".slick-slider:not(.slick-initialized)");

            if (wrapper.classList.contains("minicart-recommendations-slider")) {
                if (carousel) {
                    $(carousel).slick(miniCartSlickSettings);
                }
            } else if (carousel && $(carousel).closest(".c-anniversary-carousel--slot").length) {
                $(carousel).slick(anniversarySlickSettings);
            } else {
                if (carousel) {
                    $(carousel).slick(slickSettings);
                }
            }

            lazyLoading.refreshLazyLoadingFeature();
        });

        observer.observe(wrapper, {subtree: true, childList: true});
    });
};

/**
* Generates a custom pagination button element for use in a carousel or slider.
* @returns {jQuery} A jQuery object representing a button element for pagination.
*/
function customPagination() {
    return $(`<button type="button"></button>`);
}

var slickCarousel = {
    /**
     * @function
     * @description - run observer for the einstein injected elements
     */
    initEinstein: function () {
        if ($(".c-product-slider__cart-recommendations").length < 1) {
            runMutationsObserver(document.querySelectorAll(".m-recommendations-slider"));
        }
    },
    /**
     * @function
     * @description - caches dom elements used as vars and returns an object
     */

    initCache: function () {
        var $cache = {
            slickElement: $(document).find(".slick-slider")
        };

        return $cache;
    },

    /**
     * @function
     * @description - initializes each instance of the carousel found, based on the param passed
     */
    initSlickSlider: function (element) {
        var $element = $(element);

        $element.each(function () {
            var $this = $(this);

            if ($this.hasClass("slick-initialized")) {
                return false;
            }

            if ($this.closest(".m-product-detail__main-carousel").length > 0) {
                $this.slick(productPageSlickSettings);
            } else if ($this.closest(".m-product-detail__thumb-images").length > 0) {
                $this.slick(productPageThumbSlickSettings);
            } else if ($this.closest(".m-product-detail__players-carousel").length > 0) {
                $this.slick(playersCarouselSlickSettings);
            } else if ($this.closest(".m-blog-article__related-articles-slider").length > 0) {
                $this.slick(blogTilesCarouselSlickSettings);
            } else if ($this.closest(".m-product-selector").length > 0) {
                setTimeout(function () {
                    $this.slick(productSelectorSlickSettings);
                }, 50);
            } else if ($this.closest(".m-product-launch-section__slider-content").length > 0 || $this.closest(".pd-product-launch-section__slider-content").length > 0) {
                $this.slick(productLaunchTilesCarouselSlickSettings);
            } else if ($this.closest(".slider-minicart").length > 0) {
                $this.slick(miniCartSlickSettings);
            } else if ($this.closest(".m-homepage__promo-slider").length > 0 || $this.closest(".c-promo-slider-banner").length > 0) {
                $this.slick(promoSliderSlickSettings);
            } else if ($this.closest(".m-zoom-popin__slider").length > 0) {
                $this.slick(zoomPopinSliderSettings);
            } else if ($this.closest(".c-product-slider__cart-slider").length > 0) {
                $this.slick(cartProductSlickSettings);
            } else if ($this.closest(".c-anniversary-carousel--slot").length > 0) {
                $this.slick(anniversarySlickSettings);
            } else if ($this.closest(".c-anniversary-carousel--product").length > 0) {
                $this.slick(anniversarySlickSettings);
            } else if ($this.closest(".pd-carousel").length > 0) {
                $this.slick(pdCarouselSlickSettings);
            } else if ($this.closest(".c-anniversary-carousel").length > 0) {
                $this.slick(anniversaryStoriesCarouselSlickSettings);
            } else {
                slickSettings = $this.attr("data-slick-settings") ? JSON.parse($this.attr("data-slick-settings")) : slickSettings;
                $this.slick(slickSettings);
                if ($this.find(".slick-slide").length < 3) {
                    $this.addClass("slick-slider--centered");
                }
            }
        });

        $(window).on(
            "resize",
            debounce(function () {
                $element.each(function () {
                    var $this = $(this);

                    if (!($this.hasClass("stringing-slider") && window.mqRespond.status.lgDown)) {
                        if ($this.closest(".m-product-launch-section__slider-content").length > 0) {
                            productLaunchVideoSliderInit.playVideoIframeInPopup();
                        }

                        if ($this.closest(".c-product-slider__container").length > 0 && $this.find(".slick-slide").length < 3) {
                            if ($this.hasClass("slick-initialized")) {
                                $this.slick("unslick");
                            }

                            $this.addClass("slick-slider--centered");
                            $this.slick(slickSettings);
                        }

                    }
                });

                const $stringingTooltipTrigger = $(".stringing-tooltip");

                if (!window.mqRespond.status.lgDown && $stringingTooltipTrigger.length) {
                    if ($stringingTooltipTrigger.next(".tooltip.show").length) {
                        $stringingTooltipTrigger.next(".tooltip").remove();
                    }

                    $("[data-toggle='tooltip']").each((i, el) => {
                        $(el).tooltip({
                            container: $(el).parent(),
                            placement: "bottom",
                            delay: { "show": 2000, "hide": 100 }
                        });
                    });
                }
            }, 300)
        );
    },

    init: function () {
        var $cache = this.initCache();

        if (!$cache.slickElement) {
            $cache.slickElement = $(".slick-slider");
        }

        this.initSlickSlider($cache.slickElement);
        this.initEinstein();
    },

    syncProductLaunchCarousel: function () {
        $(".slider-product-launch-for").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            asNavFor: ".slider-product-launch-nav",
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: true,
                        customPaging: customPagination,
                        arrows: true
                    }
                }
            ]
        });

        $(".slider-product-launch-nav").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: ".slider-product-launch-for",
            dots: true,
            customPaging: customPagination,
            arrows: true,
            centerMode: false,
            infinite: false,
            focusOnSelect: true,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: true,
                        customPaging: customPagination,
                        arrows: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false
                    }
                }
            ]
        });
    }
};

module.exports = slickCarousel;
